var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Default',[_c('Hero'),_c('Content'),_c('Process'),_c('Partner')],1)}
var staticRenderFns = []

export { render, staticRenderFns }